import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import { useEffect, useRef, useState } from "react";
import "./OtpDialog.css";
import { t } from "i18next";
import { nextStep } from "../../Services/api-service";
import { isNullOrEmpty } from "../../Services/service";

function OtpDialogWidget({ objectDto, onClose, setObjectDto, setIsLoading, setChangeEmail, imgFront, imgBack }) {
  const length = 6;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  document.body.style.overflow = "hidden";

  const handleChangeEmail = () => {
    localStorage.removeItem("###");
    setChangeEmail(true);
    onClose();
  };

  const handleSubmit = (otp) => {
    var db = {...objectDto, otp: otp, idtype: 0};
    setIsLoading(true);
    nextStep(db, setObjectDto, setIsLoading).then((data)=>{
      if(data === undefined){
        setOtp(new Array(length).fill(""));
        inputRefs.current[0].focus();
      };
    });
  };
  const handleResendOtp = () => {
    setIsLoading(true);
    nextStep({...objectDto, step: 3}, setObjectDto, setIsLoading);
    localStorage.setItem("###", objectDto.expiredOtp*60);
    setOtp(new Array(length).fill(""));
    setTimeLeft(objectDto.expiredOtp*60);
    setWrong(false);
  };

  const handleChange = async (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    const combinedOtp = newOtp.join("");

    if (combinedOtp.length === length) {
      return handleSubmit(combinedOtp);
    }
    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleClick = (index) => {
    inputRefs.current[index].setSelectionRange(1, 1);
    if (index > 0 && !otp[index - 1]) {
      inputRefs.current[otp.indexOf("")].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };

  const [timeLeft, setTimeLeft] = useState(!isNullOrEmpty(localStorage.getItem("###")) ? localStorage.getItem("###") : objectDto.expiredOtp*60);
  
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    const pageHeight = document.documentElement.scrollHeight;
    const pageWidth = document.documentElement.scrollWidth;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const centerX = (pageWidth - viewportWidth) / 2;
    const centerY = (pageHeight - viewportHeight) / 2;
    window.scrollTo(centerX, centerY);
    if(isNullOrEmpty(localStorage.getItem("###"))){
      localStorage.setItem("###", objectDto.expiredOtp*60);
    }else{
      setTimeLeft(localStorage.getItem("###"))
    }
    setChangeEmail(false);
  }, []);
  useEffect(() => {
    if (timeLeft === 0) {
      setWrong(true);
      return;
    }
    localStorage.setItem("###", timeLeft);
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes < 10 ? "0" : ""}${minutes}:${
    seconds < 10 ? "0" : ""
  }${seconds}`;
  const [wrong, setWrong] = useState(false);

  return (
    <>
    {/* <ToastContainer newestOnTop={true} autoClose={15000} /> */}
    <div className="otp-dialog-overlay">
      <div className="otp-dialog">
        <h2>{t("verifyOtp")}</h2>
        <p className="desc-otp">
          {t("verifyOtp1")}
          <strong style={{ color: "#007AFF" }}>{objectDto.email}</strong>
          {t("verifyOtp2")}
          {!wrong ? (
            <>{t("verifyOtp3") + formattedTime + t("minute")}</>
          ) : (
            <p style={{ color: "red" }}>{t("otpexpired")}</p>
          )}
        </p>

        <div className="otp-actions">
          <div className="otp-input-container">
          {
            !wrong ?
              <div className="otp-input-label">
                {
                  otp.map((value, index) => {
                    return (
                      <input
                        key={index}
                        inputMode="numeric"
                        type="text"
                        ref={(input) => (inputRefs.current[index] = input)}
                        value={value}
                        onChange={(e) => handleChange(index, e)}
                        onClick={() => handleClick(index)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        className="otp-input"
                      />
                    );
                  })
                }
                </div>
              : <></>
            }
            <div className="otp-input-button">
              <CustomButtonColor
                size={"large"}
                title={t("changeEmail")}
                color={"#fff"}
                borderRadius={"5px"}
                bgColor={"#c59812"}
                onClick={handleChangeEmail}
              />
              <CustomButtonColor
                size={"large"}
                title={wrong ? t("resendOtp") : t("confirmOtp")}
                color={"#fff"}
                borderRadius={"5px"}
                bgColor={"#c59812"}
                onClick={wrong ? handleResendOtp : handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
export default OtpDialogWidget;
